import { useQuery } from "@tanstack/react-query";
import { useApi, type CategoryDTO } from "api";

export const useCategoryBusinesses = ({
  id,
  page = 1,
  pageSize = 1,
}: {
  id: CategoryDTO["id"];
  page?: number;
  pageSize?: number;
}) => {
  const { api } = useApi();

  const query = useQuery({
    queryKey: ["category-businesses", id, page, pageSize],
    queryFn: () =>
      api.publicBusiness.getAllByCategory(id!, {
        page: page - 1,
        size: pageSize,
      }),
    placeholderData: {
      content: [],
      totalElements: 0,
    },
    enabled: !!id,
  });

  return {
    loading: query.isFetching,
    loaded: query.isFetched,
    businesses: query.data?.content || [],
    totalCount: query.data?.totalElements || 0,
  };
};
